module.exports = __webpack_public_path__ + "img/money-pound-circle-fill.af7ecb45.svg";